<template>
  <div>
    <!-- A: {{activeTabHash}}
    S: {{selectedTabHash}} -->
    <div class="tabs-component clearfix">
      <ul role="tablist"
        :class="{
          'tabs-component-tabs': true,
          'no-tab-selected': !activeTabHash,
          'tab-selected': activeTabHash
        }">
        <li
          v-for="(tab, i) in tabs"
          :key="i"
          :class="{
            'is-active': tab.isActive,
            'is-disabled': tab.isDisabled,
            'is-selected': tab.hash === selectedTabHash
          }"
          class="tabs-component-tab"
          role="presentation"
          v-show="tab.isVisible">
          <!-- <input type="radio" /> -->
          <a
            :aria-controls="tab.hash"
            :aria-selected="tab.isActive"
            @click.prevent="selectTab(tab.hash, $event)"
            :href="tab.hash"
            class="tabs-component-tab-a"
            role="tab">
            <renderSlotWrapper
              v-if="tab.$scopedSlots.label"
              :label-slot="tab.$scopedSlots.label"
              :scope="{ noActiveTab: !activeTabHash }" />
            <renderSlotWrapper
              v-else-if="tab.$slots.label"
              :label-slot="tab.$slots.label" />
            <div v-else>
              {{tab.name}}
            </div>
            <!-- <span v-show="!activeTabHash">#</span> -->
          </a>
        </li>
        <li class="tabs-component-tab is-final">
          <slot name="final" />
        </li>
      </ul>
      <div :class="{
        'tabs-component-panels': true,
        'no-tab-selected': !activeTabHash
      }">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

// TODO: Make sortable!!

const renderSlotWrapper = {
  props: ['labelSlot', 'scope'],
  // mounted() { console.log("----->", this.labelSlot, this.scope) },
  render: function (createElement) {
    if ( this.scope )  {
      return this.labelSlot(this.scope);
    } else {
      return this.labelSlot.pop();
    }
    // return createElement('div', label);
  }
};

export default {
  props: {
    preselectedTabHash: {
      required: false,
      default: null
    }
  },
  data: () => ({
    tabs: [],
    activeTabHash: null,
    // activeTabIndex: 0,
    selectedTabHash: ""
  }),
  computed: {},
  created() {
    this.tabs = []; // this.$children;
    // console.log("this.$children", this.$children);

    // const paneSlots = this.$slots.default.filter(vnode => vnode.tag &&
    //    vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane');
  },
  mounted() {
    // this.tabs = this.$slots.default.filter(vnode =>
    //   vnode.tag &&
    //   vnode.componentOptions &&
    //   vnode.componentOptions.Ctor.options.name === 'SidebarTabElement'
    // );

    this.tabs = this.$children.filter(tab =>
      tab.$vnode.componentOptions &&
      tab.$vnode.componentOptions.Ctor.options.name === 'SidebarTabElement'
    );

    // console.log("this.tabs", this.tabs);
    // console.log('-------------------------', this.tabs);
    // this.tabs.forEach(tab => {
    //   const tabLabelContent = (tab.$slots.label || [tab.name]).pop();
    //   if ( typeof tabLabelContent === 'object' ) {
    //     this.$nextTick(() => {
    //       console.log("tabLabelContent", tabLabelContent);
    //     })
    //   }
    // });

    if (
      this.preselectedTabHash !== null &&
      this.findTab("#" + this.preselectedTabHash)
    ) {
      this.selectTab("#" + this.preselectedTabHash);
    }
    // if (this.tabs.length) {
    //   this.selectTab(this.tabs[0].hash);
    // }
  },
  methods: {
    findTab(hash) {
      return this.tabs.find(tab => tab.hash === hash);
    },

    selectTab(selectedTabHash, event) {
      // See if we should store the hash in the url fragment.
      const selectedTab = this.findTab(selectedTabHash);
      if (!selectedTab) {
        return;
      }
      if (selectedTab.isDisabled) {
        return;
      }
      // this.tabs.forEach(tab => {
      //   tab.isActive = tab.hash === selectedTab.hash;
      // });
      this.$emit("tab-click", selectedTab);
      this.activeTabHash = selectedTab.hash;
      // this.activeTabIndex = this.getTabIndex(selectedTabHash);
    },

    /* setTabVisible(hash, visible) {
      const tab = this.findTab(hash);
      if (!tab) {
        return;
      }
      tab.isVisible = visible;
      if (tab.isActive) {
        // If tab is active, set a different one as active.
        tab.isActive = visible;
        this.tabs.every((tab, index, array) => {
          if (tab.isVisible) {
            tab.isActive = true;
            return false;
          }
          return true;
        });
      }
    }, */

    deselectAllTabs() {
      // this.tabs.forEach(tab => {
      //   tab.isActive = false;
      // });
      this.$emit("tab-click", null);
      // console.log("deselectTab");
      this.activeTabHash = "";
      // this.activeTabIndex = 0;
    },

    getTabIndex(hash) {
      const tab = this.findTab(hash);
      return this.tabs.indexOf(tab);
    },

    // getTabHash(index) {
    //   const tab = this.tabs.find(tab => this.tabs.indexOf(tab) === index);
    //   if (!tab) {
    //     return;
    //   }
    //   return tab.hash;
    // },

    getActiveTab() {
      return this.findTab(this.activeTabHash);
    },

    getActiveTabIndex() {
      return this.getTabIndex(this.activeTabHash);
    }
  },
  components: {
    renderSlotWrapper
  }
};
</script>

<style>
.tabs-component {
  margin: 0;
}

.tabs-component-tabs {
  border: solid 1px red;
  margin-bottom: 5px;
  float: left;
  padding: 0;
}

.tabs-component-tabs.tab-selected {
  width: 100px;
}
.tabs-component-tabs.no-tab-selected {
  width: 100%;
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
  background-color: #aaa;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: block;
  padding: 0.75em 1em;
  text-decoration: none;
  position: relative;
}

.tabs-component-panels {
  border: 1px solid blue;
  padding: 0.25em;
  margin-left: 100px;
}

.tabs-component-panels.no-tab-selected {
  display: none;
}

.tabs-component-panels .close-button {
  float: right;
  margin: 0;
  padding: 5px;
}

/*
@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: block;
    margin-bottom: -1px;
  }

  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(2px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }

  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 4em 2em;
  }
} */
</style>
